import React from 'react'
import { Link } from 'react-router-dom'

import mobileAppImg from "../../assets/images/index/feedback/img-01.png";

export default function CTAMobileApp() {
  return (
    <>
        {/* <!-- MobileApp START --> */}
		<section className="bds-sectionmid">
			<div className="bds-sectionapp">
				<div className="container">
					<div className="row align-items-center">
						<div className="col-sm-12 col-lg-6">
							<div className="bds-main-title-holder bds-sectionapptitle">
								<div className="bds-maintitle">
									<h2>Stay connected to work with our mobile application</h2>
								</div>
								<div className="bds-main-description">
									<p>Download the 3bids app and choose the best contractor for your task with just three simple steps. You can also browse tasks near you and earn extra income whenever you want.</p>
								</div>
								 <a href="https://play.google.com/store/apps/details?id=com.bids.app" target="_blank" className="bds-btn-solid-lg bds-btn-yellow me-2">Download Android app <i className="icon-download"></i></a>
								 <a href="https://apps.apple.com/us/app/3-bids/id1620499159" target="_blank" className="bds-btn-solid-lg bds-btn-yellow">Download iOS app <i className="icon-download"></i></a>
								{/* <div className="bds-appcompat">
									<h6><i className="icon-bell"></i><span> This app is compatible with</span> Android and iOS devices</h6>
								</div> */}
							</div>	
						</div>
						<div className="align-self-lg-end col-md-6 col-sm-12 d-lg-block d-none">
							<figure className="bds-appiamge w-100 h-100">
								<img 
									src={mobileAppImg}
									alt="images-descp" 
									className='img-fluid' 
								/>
							</figure>
						</div>
					</div>
				</div>
			</div>
		</section>
		{/* <!-- MobileApp END --> */}
    </>
  )
}
